module.exports = __webpack_public_path__ + "img/base.893fa264.png";